import React from 'react';
import { BaseCard } from '@/components/uiKit/Cards';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePreferences } from '@/components/pages/SettingsPage/MainContent/Preferences/usePreferences';
import { Skeleton } from '@/components/ui/skeleton';
import { BaseButton } from '@/components/uiKit/Button';
import { BASE_CARD_CLASSNAMES, PUBLISH_STATUS } from '@/components/pages/SettingsPage/MainContent/Preferences/const';

export const Preferences = (): React.ReactElement => {
  const {
    notificationsEnabled,
    minimumPublishStatus,
    setNotificationsEnabled,
    setMinimumPublishStatus,
    savePreferences,
    isLoadingPreferences,
    isUpdatingPreferences,
  } = usePreferences();

  const handlePublishStatusChange = (value: string): void => {
    setMinimumPublishStatus(Number(value));
  };

  if (isLoadingPreferences) {
    return <Skeleton className="h-full" />;
  }

  return (
    <div className="flex flex-col h-full w-full gap-4">
      <div className="flex items-center min-w-full justify-end">
        <BaseButton variant="filled" size="xl" onClick={savePreferences} disabled={isUpdatingPreferences}>
          {isUpdatingPreferences ? 'Updating...' : 'Save Changes'}
        </BaseButton>
      </div>

      <BaseCard variant="wrapper" classNames={BASE_CARD_CLASSNAMES} title="Diagnostics View">
        <div>Minimum publish status</div>

        <Select
          disabled={isUpdatingPreferences}
          value={String(minimumPublishStatus)}
          onValueChange={handlePublishStatusChange}
        >
          <SelectTrigger className="w-[200px] focus:outline-none focus:ring-0 focus:ring-offset-0 border-0 rounded-none border-b-2 focus:border-b-2 hover:border-b-neutral-100">
            <SelectValue placeholder="Select publish status" />
          </SelectTrigger>
          <SelectContent>
            {PUBLISH_STATUS.map(({ value, label }) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </BaseCard>

      <BaseCard variant="wrapper" classNames={BASE_CARD_CLASSNAMES} title="Notifications">
        <div>Alerts for organization</div>
        <Switch
          disabled={isUpdatingPreferences}
          checked={notificationsEnabled}
          onCheckedChange={setNotificationsEnabled}
        />
      </BaseCard>
    </div>
  );
};
